export const sessionGroupsQueryKey = () => ['session-groups'] as const;

export const sessionGroupQueryKey = (groupId?: string | null) =>
  ['session-group', groupId] as const;
